import { AppBar, Toolbar } from "@mui/material";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../components/LanguageSwitcher";
import ini from "ini";
import { useEffect, useState } from "react";

export default function AppbarUI() {
  const [values, setValues] = useState({
    logo: "",
    logoAr: "",
  });
  const { i18n } = useTranslation();
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch("/config.ini");
        const text = await response.text();
        const parsedConfig = ini.parse(text);
        setValues({
          logo: parsedConfig.logo,
          logoAr: parsedConfig.logoAr,
        });
      } catch (error) {
        console.log(error);
      }
    };

    fetchConfig();
  }, []);
  return (
    <AppBar
      aria-label="App Bar"
      position="relative"
      elevation={0}
      sx={{
        background: "linear-gradient(to right, #300c48, #68006e)",
      }}
    >
      <Toolbar
        aria-label="Nav Bar"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          direction: i18n.language === "ar" ? "ltr" : "rtl",
        }}
      >
        <LanguageSwitcher />
        <img
          src={i18n.language === "ar" ? values.logoAr : values.logo}
          width={150}
          height={120}
          alt="fawry logo"
          style={{ color: "#fff" }}
        />
        <span></span>
      </Toolbar>
    </AppBar>
  );
}
